import { useQuery } from '@tanstack/react-query'
import { getTicketsUnreadCount } from '@/services/user.service'

export const TICKETS_UNREAD_COUNT_QUERY_KEY = ['ticketsUnreadCount']

export const useTicketsUnreadCount = (): number => {
    const { data } = useQuery({
        queryKey: TICKETS_UNREAD_COUNT_QUERY_KEY,
        queryFn: getTicketsUnreadCount,
        refetchInterval: 5 * 60 * 1000,
    })
    return data?.count || 0
}
